import { FC, ReactNode } from 'react';
import { Stack } from '@mui/material';

import {
	BookingStateEnum,
	ItineraryView,
	PassengerBookingView,
} from '@mopla/data-models';

import { MoreActions, MplFeedbackResult } from '../../../..';
import { useMoreActionsContext } from '../MoreActions/context';

import { RouteLegsDetailsMap } from './RouteLegsDetailsMap';
import { Content, ContentPaper, Root } from './styled';

export interface IRouteDetailsProps {
	route: ItineraryView;
	booking?: PassengerBookingView;
	isTicket?: boolean;
	cheaperRidesBlock?: ReactNode;
	routeDetailsHeaderBlock: ReactNode;
	cheapestRideBlock?: ReactNode;
	failedStatusBlock?: ReactNode;
	passengerInfoBlock?: ReactNode;
	cancelButtonBlock?: ReactNode;
	isCancelled?: boolean;
	cancellationFee?: number;
	invoiceContent?: ReactNode;
	passengerSummaryBlock?: ReactNode;
}

export const RouteDetails: FC<IRouteDetailsProps> = ({
	route,
	booking,
	isTicket,
	cheaperRidesBlock,
	cheapestRideBlock,
	failedStatusBlock,
	passengerInfoBlock,
	cancelButtonBlock,
	routeDetailsHeaderBlock,
	isCancelled,
	cancellationFee,
	invoiceContent,
	passengerSummaryBlock,
}) => {
	const { isMoreActionsOpen, currentBooking } = useMoreActionsContext();

	return (
		<Root data-testid="savedTicket-routeDetails-block">
			{cheapestRideBlock}
			<Stack px={3}>{routeDetailsHeaderBlock}</Stack>
			{failedStatusBlock}
			{cheaperRidesBlock && <Content>{cheaperRidesBlock}</Content>}
			<RouteLegsDetailsMap
				itinerary={route}
				isCancelled={isCancelled}
				cancellationFee={cancellationFee}
				isTicket={isTicket}
			/>
			{passengerInfoBlock}
			{booking?.bookingStatus === BookingStateEnum.FINISHED && (
				<ContentPaper>
					<MplFeedbackResult booking={booking} />
				</ContentPaper>
			)}
			{cancelButtonBlock && <Content>{cancelButtonBlock}</Content>}
			{isMoreActionsOpen && currentBooking && (
				<MoreActions
					open={isMoreActionsOpen}
					booking={currentBooking}
					additionalButtons={invoiceContent}
					passengerInfoBlock={passengerSummaryBlock}
				/>
			)}
		</Root>
	);
};
